"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendGaEvent = exports.loadHeadScript = exports.loadBodyScript = void 0;
const loadBodyScript = (url, ref) => {
    return new Promise((resolve, reject) => {
        const el = document.getElementById("simplex-body");
        if (el !== null)
            resolve();
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "simplex-body";
        script.src = url;
        script.onload = () => {
            resolve();
        };
        script.onerror = reject;
        ref.appendChild(script);
    });
};
exports.loadBodyScript = loadBodyScript;
const loadHeadScript = (url, ref) => {
    return new Promise((resolve, reject) => {
        const el = document.getElementById("simplex-head");
        if (el !== null)
            resolve();
        const script = document.createElement("script");
        script.src = url;
        script.id = "simplex-head";
        script.async = true;
        script.onload = () => {
            resolve();
        };
        script.onerror = reject;
        ref.appendChild(script);
    });
};
exports.loadHeadScript = loadHeadScript;
const sendGaEvent = ({ category = "buy", action, label, }, cb) => {
    if (window && window.ga) {
        let options;
        if (cb !== undefined)
            options = { hitCallback: cb };
        window.ga("create", "UA-59964190-1", "auto", "bitcoincom-buy");
        const tracker = window.ga.getByName("bitcoincom-buy");
        tracker.send("event", category, action, label, options);
    }
    else if (cb !== undefined) {
        cb();
    }
};
exports.sendGaEvent = sendGaEvent;
//# sourceMappingURL=helpers.js.map